const ENDPOINTS = {
  getHeader: "csrf-cookie",
  login: "login",
  logout: "dashboard/logout",
  users: "users",
  roles: "roles",
  customers: "customers",
  requests: "requests",
  reports: "reports/services",
  services: "services",
  categories: "settings/categories",
  usecases: "useCases",
  sliders: "sliders",
  clicks: "clicks",
  coupons: "coupons",
  plans: "membership/plans",
  wheelReport: "reports/wheel",
  score: "settings/points",
  conversions: "points/conversions",
  prizes: "wheelOfFortune/prizes",
  wheel: "wheelOfFortune/wheels",
  faqs: "faqs",
  payments: "payments",
  layout: "settings/home-layouts",
  games: "/games",
  notification: "/notification/send",
  searchGroup: "/customers/search",
};

export default ENDPOINTS;
